module.exports = __webpack_public_path__ + "media/components/util/logos/vecteezy-logo--orange-on-white-896315bbe0e1d2b6ab3f99334c00fb37.svg";